import { Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ToolbarItem } from '../../interfaces/tool-bar-item.interface';
import { ToolBarComponent, ToolBarModule } from '@progress/kendo-angular-toolbar';
import { CustomToolBarComponent } from '../custom-tool-bar/custom-tool-bar.component';

@Component({
    selector: 'app-tool-bar',
    imports: [ToolBarModule, CustomToolBarComponent],
    templateUrl: './tool-bar.component.html',
    styleUrls: ['./tool-bar.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolbarListComponent  {

  @ViewChild('toolbar') bar: ToolBarComponent;

  @Input() items: ToolbarItem[];

  constructor() { }

  itemSelected(item: ToolbarItem) {

  }

}
